module.exports = __webpack_public_path__ + "static/img/17.4873fc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/17.png
// module id = ZXBO
// module chunks = 1